/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KeyType } from './keyType';
import { DisconnectedComponent } from './disconnectedComponent';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface DisconnectedVLRRequestModel { 
    components?: Array<DisconnectedComponent>;
    /**
     * Creation Timestamp
     */
    creation_time?: Date;
    deactivation_code?: string;
    key_type?: KeyType;
    sequence_number?: number;
    vcds_service_type?: VcdsServiceTypeEnum;
}
export namespace DisconnectedVLRRequestModel {
}


